import {Injectable} from '@angular/core';
import {AbstractService} from './abstract.service';
import {AppConfigService} from './app-config.service';
import {LoggedUserService} from './logged-user.service';
import {
  ClaimLawsuitBaseDto,
  ClaimLawsuitCriteriaDto,
  ClaimLawsuitDto,
  SearchCriteria,
  StateTransitionDto,
} from '../model/dtos';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Cacheable} from 'ts-cacheable';

@Injectable()
export class ClaimLawsuitService extends AbstractService {
  protected url = this.urlPrefix + 'claim/lawsuit';

  constructor(public http: HttpClient, appConfigService: AppConfigService, loggedUserService: LoggedUserService) {
    super(http, appConfigService, loggedUserService);
  }

  findLawsuitVersionsByClaimId(claimId: number): Observable<ClaimLawsuitBaseDto[]> {
    const crit = <SearchCriteria<ClaimLawsuitCriteriaDto>>{
      criteria: {claim: {id: claimId}},
    };
    return this.searchByCriteria(crit).pipe(map((x) => <ClaimLawsuitBaseDto[]>x.result));
  }

  getInitialVersion(parentId: number): Observable<ClaimLawsuitDto> {
    return this.get(this.url + '/initialVersion?claimId=' + parentId);
  }

  getLastVersionByClaimId(parentId: number): Observable<ClaimLawsuitDto> {
    return this.get<ClaimLawsuitDto>(this.url + '/lastVersion/' + parentId);
  }

  getTransitions(claimLawsuit: ClaimLawsuitDto): Observable<Array<StateTransitionDto>> {
    return this.get<StateTransitionDto[]>(this.url + '/transition/' + claimLawsuit.businessStatus.id);
  }

  @Cacheable()
  getTransitionsMap(): Observable<Map<number, Array<StateTransitionDto>>> {
    return this.get<Map<number, Array<StateTransitionDto>>>(this.url + '/transition');
  }
}
